import * as Barba from '../libs/barba';
import { scrollTop } from './transitions/scrollTop';

export function manageTransitions (namespace) {
  Barba.Pjax.getTransition = function() {
    return scrollTop;
  };
}
